<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('order_package_packingType') || '装箱方式'"
            prop="packingType"
          >
            <dict-select
              v-model="formData.packingType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'packingType' }"
              :placeholder="
                this.$l('tips_order_package_packingType') || '请选择装箱方式'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="this.$l('order_packing_materialNo') || '物料编号'"
            ref="material"
            prop="materialNo"
          >
            <el-input clearable v-model="formData.materialNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePackage"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="7">
          <el-form-item
            :label="$l('order_packing_dispatchPort') || '发运港口'"
            prop="dispatchPort"
          >
            <dict-select
              v-model="formData.dispatchPort"
              url="/master/port/select"
              :placeholder="
                this.$l('tips_order_packing_dispatchPort') || '请选择发运港口'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('order_packing_destinationPort') || '目的港口'"
            prop="destinationPort"
          >
            <dict-select
              v-model="formData.destinationPort"
              url="/master/port/select"
              :placeholder="
                this.$l('tips_order_packing_destinationPort') ||
                  '请选择目的港口'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('order_packing_outBillType') || '出单类型'"
            prop="outBillType"
          >
            <dict-select
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'outBillType' }"
              :placeholder="
                this.$l('tips_order_packing_outBillType') || '请选择出单类型'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('order_package_materialName') || '物料名称'"
          >
            <el-input v-model="formData.materialName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('order_package_materialNameEn') || '英文名称'"
          >
            <el-input
              v-model="formData.materialDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="this.$l('order_package_boxUnitPrice') || '箱单价'"
          >
            <el-input-number
              v-model="formData.boxUnitPrice"
              :min="0"
              :max="9999999999"
              :precision="4"
              :step="1"
              controls-position="right"
              style="width: 100%"
              :placeholder="
                this.$l('tips_order_package_boxUnitPrice') || '请输入箱单价'
              "
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$l('order_package_materialSize') || '包装尺寸'"
          >
            <el-input v-model="formData.materialSpec" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="this.$l('order_package_boxWeight') || '包装箱重量'"
          >
            <el-input v-model="formData.boxWeight" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="this.$l('order_package_boxVolume') || '包装箱体积'"
          >
            <el-input v-model="formData.boxVolume" readonly></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            :label="this.$l('order_package_orderPackingDesc') || '装箱方案描述'"
          >
            <el-input
              v-model="formData.orderPackingDesc"
              type="textarea"
              :placeholder="this.$l('tips_order_packing_orderPackingDesc')"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :maxlength="250"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
          <el-form-item
            :label="$l('order_package_isSpecify') || '客户指定供应商'"
            ><br />
            <el-radio-group v-model="formData.isSpecify" disabled>
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <dict-select
              size="small"
              clearable
              disabled
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <GoodsTable
        ref="goodsTable"
        class="mt-2"
        :disabled="disabled"
        :orderCode="orderCode"
        :packingType="formData.packingType"
        :tableData.sync="formData.items"
      />
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <ChoosePackage
      :title="$l('order_packing_choose_package_title') || '选择包装箱'"
      :visible.sync="visible"
      :orderCode="orderCode"
      @confirm="choosePackageConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GoodsTable from './goods-table.vue'
import ChoosePackage from '../choose-package/dialog.vue'
const initFrom = {
  packingType: '',
  outBillType: 'storeBill',
  dispatchPort: '',
  destinationPort: '',
  materialNo: '',
  items: [],
}
export default {
  mixins: [EditLoading],
  components: { GoodsTable, ChoosePackage },
  props: {
    disabled: { type: Boolean, default: false },
    orderCode: { type: String, default: '' },
    orderPackingCode: { type: String, default: '' },
    isCopy: Boolean,
  },
  watch: {},
  data() {
    return {
      backDialogVisible: false,
      visible: false,
      formData: { ...initFrom },
      tableData: [],
      rules: {
        packingType: [
          {
            required: true,
            message:
              this.$l('tips_order_package_packingType') || '请选择装箱方式',
            trigger: 'change',
          },
        ],
        outBillType: [
          {
            required: true,
            message:
              this.$l('tips_order_packing_outBillType') || '请选择出单类型',
            trigger: 'change',
          },
        ],
        // dispatchPort: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('tips_order_packing_dispatchPort') || '请选择发运港口',
        //     trigger: 'change',
        //   },
        // ],
        // destinationPort: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('tips_order_packing_destinationPort') || '请选择目的港口',
        //     trigger: 'change',
        //   },
        // ],
        materialNo: [
          {
            required: true,
            message: this.$l('tips_order_packing_materialNo') || '请选择包装',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderPackingCode) return
      this.$api
        .ordeDemandPackingDetailApi({
          orderPackingCode: this.orderPackingCode,
        })
        .then((res) => {
          this.formData = res.body
          // null 转 undefined，避免 el-input-number 回显成 0
          if (this.formData.boxUnitPrice === null) this.formData.boxUnitPrice = undefined
          this.formData.materialSize =
            this.formData.boxLength +
            'x' +
            this.formData.boxWidth +
            'x' +
            this.formData.boxHeight +
            ' cm'
          if (this.isCopy) {
            this.formData.orderPackingCode = ''
            const packingList = this.formData.items
            packingList.forEach((item) => {
              item.orderPackingGoodsCode = ''
            })
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      this.loadingOpen()
      this.$api
        .ordeDemandPackingSaveApi({
          ...this.formData,
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    openChoosePackage() {
      this.visible = true
    },
    choosePackageConfirm(data) {
      if (!data) return
      this.formData.orderPackageCode = data.orderPackageCode
      this.formData.materialNo = data.materialNo
      this.formData.materialName = data.materialName
      this.formData.materialDisplayName = data.materialDisplayName
      this.formData.materialSpec = data.materialSpec
      this.formData.boxWeight = data.boxWeight
      this.formData.boxVolume = data.boxVolume
      this.formData.isSpecify = data.isSpecify
      this.formData.scmCode = data.scmCode
    },
  },
}
</script>
